export default "__VITE_ASSET__JSl4K1Ec__"